export default "__VITE_ASSET__9d8507c7__"